import Api from '@vacationtracker/shared/services/api'
import { EventRefPage } from '@vacationtracker/shared/types/core-event'

export function postCoreEvent(body: object, refPage: EventRefPage) {
  return Api.post('/core/event', { ...body, refPage })
}
